import team from "../data/team.json";
import TeamCard from "../components/Team/TeamCard";

function Team() {
    return (
        <div className="container mx-auto w-3/4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-x-10 gap-y-6">
                {team.people.map((person, index) =>
                    <TeamCard key={index} person={person}/>
                )}
            </div>
        </div>
    );
}

export default Team;
